<!--模板界面-->
<template>
	<div class="bg">
		<p class="titleText">年用电量</p>
		<img src="../../../../public/static/杭州东杰定制/看板/站点概况/titleBottom.png" style="margin: 10px 0;width: 100%;">
		<p style="padding: 0 10px;margin-bottom: 5px;">今年用电量:<span style="font-size: 18px;font-weight: bold;color: #c95730;">{{yearPowerValue}}</span>
			k·Wh</p>
		<div class="flexBetween" style="height: 60px;margin: 0 10px;">
			<div style="background: #3080f9;width: calc(50% - 5px);height: 100%;" class="flexBetween">
				<div class="bigBox flexCenterColumn">
					<p>今日用电量</p>
					<p>{{day1}}</p>
					<p>k·Wh</p>
				</div>
				<div style="width: calc(100% - 90px);">
					<div class="flexBetween info">
						<p class="tb">同比</p>
						<p>上月同期:</p>
						<p style="width: 40px;text-align: center;">{{day3}}</p>
						<img :src="getIco(day3Compare)">
						<p style="width: 30px;text-align: center;">{{day3Compare}}</p>
					</div>
					<div class="flexBetween info" style="margin-top: 15px;">
						<p class="tb">环比</p>
						<p>昨日同期:</p>
						<p style="width: 40px;text-align: center;">{{day2}}</p>
						<img :src="getIco(day2Compare)">
						<p style="width: 30px;text-align: center;">{{day2Compare}}</p>
					</div>
				</div>
			</div>
			<div style="background: #ec7412;width: calc(50% - 5px);height: 100%;" class="flexBetween">
				<div class="bigBox flexCenterColumn">
					<p>本月用电量</p>
					<p>{{month1}}</p>
					<p>k·Wh</p>
				</div>
				<div style="width: calc(100% - 90px);">
					<div class="flexBetween info">
						<p class="tb">同比</p>
						<p>去年同期:</p>
						<p style="width: 40px;text-align: center;">{{month3}}</p>
						<img :src="getIco(month3Compare)">
						<p style="width: 30px;text-align: center;">{{month3Compare}}</p>
					</div>
					<div class="flexBetween info" style="margin-top: 15px;">
						<p class="tb">环比</p>
						<p>上月同期:</p>
						<p style="width: 40px;text-align: center;">{{month2}}</p>
						<img :src="getIco(month2Compare)">
						<p style="width: 30px;text-align: center;">{{month2Compare}}</p>
					</div>
				</div>
			</div>
		</div>
		<vchart ref='vchartBar' themes="dongjieEchart"></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				barOption: {
					xAxis: [{
						type: 'category',
						data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
							'20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'
						],
					}],
					yAxis: [{
						title: '能耗值（KWH）',
						type: 'value',
					}],
					legend: {
						top: '125px',
						data: ['电量', '电费'],
						textStyle: {
							color: '#2e328e'
						}
					},
					backgroundColor: '',
					tooltip: {
						trigger: 'axis',
						formatter: '{b}日<br/>{a}: {c}KWH<br />{a1}: {c1}元'
					},
					grid: {
						height: '80%',
						left: '1%',
						right: '0',
						bottom: '5%',
						containLabel: true
					},
					series: [],
				},
				powerDateList: {},
				yearPowerValue: undefined,
				day1: undefined, //今日
				day2: undefined, //上月同期
				day3: undefined, //昨日同期
				month1: undefined,
				month2: undefined,
				month3: undefined,
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.$refs.vchartBar.setData(this.barOption)
			this.powerDate(this.nowUnit.id)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			day2Compare() {
				return this.compareValue(this.day1, this.day2)
			},
			day3Compare() {
				return this.compareValue(this.day1, this.day3)
			},
			month2Compare() {
				return this.compareValue(this.month1, this.month2)
			},
			month3Compare() {
				return this.compareValue(this.month1, this.month3)
			},
			getIco() {
				return value => {
					if (value == '--' || value == 0) {
						return ''
					}
					return value > 0 ? '/static/杭州东杰定制/看板/年用电量/up.png':'/static/杭州东杰定制/看板/年用电量/down.png'
				}
			}
		},
		watch: {
			powerDateList(nv, ov) {
				var money = []
				var power = []
				if (!isempty(nv)) {
					Object.keys(nv).forEach(function(key) {
						var pw = nv[key]['总电量']
						var my = nv[key]['总电费']
						if (isNaN(parseFloat((my))) || isnull(parseFloat((my)))) {
							my = undefined
						}
						if (isNaN(parseFloat((pw))) || isnull(parseFloat((pw)))) {
							pw = undefined
						}
						money.push(my)
						power.push(pw)
					})
				}
				this.barOption.series = [{
					name: '电量',
					type: 'bar',
					data: power
				}, {
					name: '电费',
					type: 'bar',
					data: money
				}]
				this.$refs.vchartBar.setData(this.barOption, true)
			},
			nowUnit(nv, ov) {
				this.powerDate(nv.id)
			}
		},
		methods: {
			compareValue(a, b) {
				if (a == 0 || b == 0 || a == undefined || b == undefined) {
					return "--"
				}
				return cutDigital((a - b) / b * 100) + "%"
			},
			powerDate(unitId) {
				if (isempty(unitId)) {
					return
				}
				var now = new Date(getDay(-1))
				var nowTime = now.getTime()
				var year = now.getFullYear()
				var month = now.getMonth()
				var day = now.getDate()
				var nowZero = new Date(year, month, day).getTime()
				//获取今年用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, 0, 1).getTime(), nowTime, respon => {
					this.yearPowerValue = Number(respon)
				})
				//获取今日电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, nowZero, nowTime, respon => {
					this.day1 = Number(respon)
				})
				//获取昨日电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, nowZero - 24 * 60 * 60 * 1000, nowZero - 1, respon => {
					this.day2 = Number(respon)
				})
				//获取上个月同一天用电量，直接月份减1如果不存在就是空
				var lastMonthDate = new Date(year, month - 1, day)
				if (lastMonthDate.getMonth() != 12 && lastMonthDate.getMonth() != now.getMonth() - 1) {
					this.day3 = undefined
				} else {
					this.$api.powerApi.getUnitUsePowerByDate(unitId, lastMonthDate.getTime(), lastMonthDate.getTime() + 24 * 60 * 60 *
						1000 - 1, respon => {
							this.day3 = Number(respon)
						})
				}
				//获取本月用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month, 1).getTime(), nowTime, respon => {
					this.month1 = Number(respon)
				})
				//获取上月用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year, month - 1, 1).getTime(), new Date(year, month, day)
					.getTime() -
					1, respon => {
						this.month2 = Number(respon)
					}, repon => {
						this.month2 = undefined
					})
				//获取去年同月用电量
				this.$api.powerApi.getUnitUsePowerByDate(unitId, new Date(year - 1, month, 1).getTime(), new Date(this.getLastDay(
					year - 1, month + 1)).getTime(), respon => {
					this.month3 = Number(respon)
				}, respon => {
					this.month3 = undefined
				})
				//每月用电
				this.powerDateList = []
				var id = this.nowUnit.id
				this.$api.powerApi.getClassPGByMonthForHuaPu(new Date().getTime(), this.nowUnit.id, respon => {
					if (id == this.nowUnit.id) { //接口延迟时 只赋值当前的unit结果
						this.powerDateList = respon
					}
				})
			},
			getLastDay(year, month) {
				var new_year = year; //取当前的年份          
				var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）          
				if (month > 12) {
					new_month -= 12; //月份减          
					new_year++; //年份增          
				}
				var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天          
				return year + '-' + new_month + '-' + (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate(); //获取当月最后一天日期          
			}
		}
	}
</script>

<style scoped>
	>>>.default-chart {
		height: calc(100% - 150px) !important;
		width: 100% !important;
	}

	.bigBox {
		width: 80px;
		height: 100%;
		border-right: 1px white dashed;
	}

	.bigBox>p:nth-of-type(2) {
		font-size: .16rem;
		font-weight: bold;
	}

	.tb {
		border: 1px white solid;
		border-radius: 5px;
		padding: 0 8px;
		margin-right: 10px;
	}

	.info {
		margin-right: 10px;
	}

	.info p {
		font-size: .1rem;
		height: .15rem;
		margin-right: 5px;
	}

	.info>img {
		height: 12px;
		padding: 2px;
	}
</style>
